/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;

// const accessTokenFromLocal = "0fc0515a-d081-4b4a-83ab-7c104c2e1357";

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });

export default class IntroductionForm {
  static getAllArea({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/structures/areas", {
      accessToken: accessTokenFromLocal,
      data,
    })
       .then((response) => {
      return response;
    })
    .catch((error) => {
      // ✅ If token expired / unauthorized
      if (error?.status === 401) {
        localStorage.clear();
        sessionStorage.clear();

        window.location.href = "/";
      }

      throw error;
    });

    IntroductionForm.getAllArea.cancel = request.cancel;
    return request;
  }

  static getAllClusters({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/structures/cluster", {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getAllClusters.cancel = request.cancel;
    return request;
  }

  static getAllZonesForOldRecords({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/structures/zones-old-record", {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getAllZonesForOldRecords.cancel = request.cancel;
    return request;
  }

  static getAllZones({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/structures/zones", {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getAllZones.cancel = request.cancel;
    return request;
  }

  static getAllRegions({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/structures/regions", {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getAllRegions.cancel = request.cancel;
    return request;
  }

  static getAllChapters({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/structures/chapters", {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getAllChapters.cancel = request.cancel;
    return request;
  }

  static getAllDistricts({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/structures/districts", {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getAllDistricts.cancel = request.cancel;
    return request;
  }

  static getAllBlocks({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/structures/blocks", {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getAllBlocks.cancel = request.cancel;
    return request;
  }

  static getAllDivisions({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/structures/divisions", {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getAllDivisions.cancel = request.cancel;
    return request;
  }

  static getGeoLocator({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/geoLocator", {
      data,
      accessToken: accessTokenFromLocal,
    });

    IntroductionForm.getGeoLocator.cancel = request.cancel;
    return request;
  }

  static getAllPositions(type) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/masters/positions?type=${type}`, {
      accessToken: accessTokenFromLocal,
    });

    IntroductionForm.getAllPositions.cancel = request.cancel;
    return request;
  }

  static postIntroductions({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post("/api/introductions", {
      data,
      accessToken: accessTokenFromLocal,
    });

    IntroductionForm.postIntroductions.cancel = request.cancel;
    return request;
  }

  static searchMembers({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/introductions/searchMember", {
      data,
      accessToken: accessTokenFromLocal,
    });

    IntroductionForm.searchMembers.cancel = request.cancel;
    return request;
  }

  static getDivisions() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/masters/divisions", {
      accessToken: accessTokenFromLocal,
    });

    IntroductionForm.getDivisions.cancel = request.cancel;
    return request;
  }

  static getStates() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/masters/states", {
      accessToken: accessTokenFromLocal,
    });

    IntroductionForm.getStates.cancel = request.cancel;
    return request;
  }

  static getCountries() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/masters/countries", {
      accessToken: accessTokenFromLocal,
    });

    IntroductionForm.getCountries.cancel = request.cancel;
    return request;
  }

  // static getProfileData() {
  //   const accessTokenFromLocal = localStorage.getItem("authToken");
  //   const request = get("/api/profile", {
  //     accessToken: accessTokenFromLocal,
  //   });

  //   IntroductionForm.getProfileData.cancel = request.cancel;
  //   return request;
  // }

  static getProfileData() {
  const accessTokenFromLocal = localStorage.getItem("authToken");

  const request = get("/api/profile", {
    accessToken: accessTokenFromLocal,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // ✅ If token expired / unauthorized
      if (error?.status === 401) {
        console.log("UnAuthorize Access");

        localStorage.clear();
        sessionStorage.clear();

        window.location.href = "/";
      }

      throw error;
    });

  IntroductionForm.getProfileData.cancel = request.cancel;

  return request;
}

  static switchProfileData(data) {
    // console.log(data);
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put("/api/profile/switch", {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.switchProfileData.cancel = request.cancel;
    return request;
  }

  static getUserInfo(introductionId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/introductions/${introductionId}`, {
      accessToken: accessTokenFromLocal,
    });

    IntroductionForm.getUserInfo.cancel = request.cancel;
    return request;
  }

  static cancelIntro({ data }) {
    const accessToken = localStorage.getItem("authToken");
    const request = post(`/api/introductions/cancel`, {
      accessToken,
      data,
    });

    IntroductionForm.cancelIntro.cancel = request.cancel;
    return request;
  }

  static getProfessions() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/masters/professions", {
      accessToken: accessTokenFromLocal,
    });

    IntroductionForm.getProfessions.cancel = request.cancel;
    return request;
  }

  static getUniversity() {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get("/api/masters/universities", {
      accessToken: accessTokenFromLocal,
    });

    IntroductionForm.getUniversity.cancel = request.cancel;
    return request;
  }

  static getBlocks({ districtId, data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/structures/blocks?districtId=${districtId}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getBlocks.cancel = request.cancel;
    return request;
  }

  static getCluster({ areaId, data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/structures/cluster?areaId=${areaId}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getCluster.cancel = request.cancel;
    return request;
  }

  static getZones({ clusterId, data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/structures/zones?clusterId=${clusterId}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getZones.cancel = request.cancel;
    return request;
  }

  static getRegions({ zoneId, data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/structures/regions?zoneId=${zoneId}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getRegions.cancel = request.cancel;
    return request;
  }

  static getChapters({ regionId, data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/structures/chapters?regionId=${regionId}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getChapters.cancel = request.cancel;
    return request;
  }

  static getDistricts({ chapterId, data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/structures/districts?chapterId=${chapterId}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    IntroductionForm.getDistricts.cancel = request.cancel;
    return request;
  }
}
